import { CuredApiPaths } from '../../models/enums';
import { UseQueryOptions } from 'react-query';
import useQuery from '../useQuery';

const useLDHash = (reactQueryOptions?: UseQueryOptions<string, Error>) =>
    useQuery('feature-flag-hash', CuredApiPaths.LD_HASH, reactQueryOptions);

export default useLDHash;
